<div class="modal-body">
  <div class="container-fluid">
    <div class="grid-col flex-auto">
        <legend class="usa-legend usa-legend--medium">Notification Preference</legend>
        
    </div>
  </div>
  <div class="grid-row">
  
    <ag-grid-angular
      style="width: 100%; height: 400px;"
      class="ag-theme-alpine"
      [gridOptions]="notificationPreferenceOptions"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [overlayNoRowsTemplate]="overlayNoRowsTemplate"
      [suppressDragLeaveHidesColumns]="true"
      (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="closeModal()">Close</button>
</div>

